const FieldMixin = {
  props: {
    noLabel: Boolean,
    inline: Boolean,
    label: String,
    value: {},
    className: String,
    rules: { type: Array, default: () => [] },
    widthLabel: { type: String, default: '150px' },
    typeInput: { type: String, default: 'v-text-field' },
    requiredText: {
      type: String,
      default: '',
    },
    required: Boolean,
    noPadding: Boolean,
    readonly: Boolean,
    placeholder: String,
  },
  computed: {
    attrBind() {
      return {
        required: this.required,
        label: this.currentlabel,
        rules: this.currentRules,
        readonly: this.readonly,
        class: this.className,
        placeholder: this.currentplaceholder,
        'validate-on-blur': false,
        ...this.$attrs,
      }
    },
    currentplaceholder() {
      if (!this.noLabel) return this.placeholder || this.label || ''
      return this.placeholder || ''
    },
    currentlabel() {
      // if (this.label) return this.label + (this.required ? ' (*)' : '')
      if (this.label) return this.label
      return ''
    },
    currentRules() {
      return [...this.rules, ...this.defaultRules]
    },
    defaultRules() {
      let defaultRules = []
      if (this.required) {
        defaultRules.push(
          (value) =>
            !!value || this.requiredText || this.$t('validation.required')
        )
      }
      return defaultRules
    },
    item: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
export default FieldMixin
